import io from "socket.io-client";
import { mapGetters } from 'vuex';
export const message ={    
    data(){
        return{
            isLoading:true,
            page:1,
            lastPage:1,
            socket: io(this.$store.state.serverDomain + ":3000"),
        }
    },
    mounted(){       
        this.listen();       
    },
    computed:mapGetters({
        messageLists:'message/getMessages'
    }),  
    methods: {
        reqDel(msgId){
            if(confirm('쪽지를 삭제 하시겠습니까?'))
            {
                this.delMessag(msgId);
                return;
            }else{
                return;
            }
        },
        listen() {
            this.socket.on("receiveMessage", (receive) => {
            console.log("쪽지가 발송 됨",receive);
            if(receive.toNic === this.user.nic)
            {
                this.page=1;
                this.getMessages();
            }
            //console.log('새로운 접속 socket.id',user.socketid);
            });
        },
        async getMessages(pagenumber,type){
            const formData = {
                user_id:this.user.id,
                page:pagenumber?pagenumber:1,
                type:type
            }
           
            const response = await this.$store.dispatch("message/getMessages", formData);
            console.log(response);
            this.lastPage = response.messages.last_page;
            this.myMsg = response.messages;
            this.isLoading= false;
            this.isLoadMore = false;
            this.$store.dispatch('message/getMessageCount',{user_id:this.user.id});//새쪽지
            //새로온 쪽지가 있으면 새로고침
            if(response.newMessage > 0)
            {
                opener.location.reload();
            }
           

            if(this.lastPage <= this.page)
            {
                //alert('더이상 데이터가 없습니다.');
                this.moreData = false;

            }
        },
        async ckMsgItem($event)
        {
            //아이템 유무 확인 있으면 사용유무를 묻고 없으면 구매유무를 확인한다.
            const ckitem =  await this.ckItem('send_msg','pop','','쪽지 이용권');
            if(!ckitem){
                return;
            }else{
                //아이템이 있을시
                if($event.target.readOnly === true)
                {
                    $event.target.readOnly = false;
                    $event.target.style.background = "#fff";
                    // if(confirm('닉네임 변경은 아이템이 필요합니다.\n아이템을 사용하시겠습니까?'))
                    // {
                    //     $event.target.readOnly = false;
                    //     $event.target.style.background = "#fff";
                    // }
                }
            }
        },
        async delMessag(type)
        {
            if(this.itemSelect.val.length === 0)
            {
                return;
            }
            if(confirm('선택된 쪽지를 삭제 하시겠습니까?'))
            {
                try {
                    const response = await this.$store.dispatch("message/deleteMessage",
                    {message_id:this.itemSelect.val, type:type})
                    console.log(response);
                    // if(response.itemBuy)
                    // {
                    //     this.$store.commit('updateUserPoint',response.user);
                    // }
                    this.$flashMessage.show({
                        type: response.state_code===201?"info":"error",
                        title: response.message,
                        message: response.message,
                    });
                }catch(error){
                    console.log(error);
                }
            }

        },
    },
}
